export default __webpack_public_path__ + "static/media/logowhite.6e924585.png";